import { useGetReportStatusQuery } from "src/common/redux/api/exopenApi.js";
import { useEwrLinkClick } from "src/common/service/useEwrLinkClick.js";
import { useLoadedCompanyDomain } from "src/routes/routeDataHooks.js";
import { ReportsWidgetView } from "./ReportsWidgetView.js";

export const ReportsWidget = () => {
	const companyDomain = useLoadedCompanyDomain();
	const { data: reportStatus } = useGetReportStatusQuery({
		companyDomainId: `${companyDomain.id}`,
	});
	const { onClick: handleEwrClick } = useEwrLinkClick(
		reportStatus?.ewrUrl ?? "",
	);

	if (
		!reportStatus?.hasEwr ||
		!reportStatus.ewrUrl ||
		reportStatus.reportModules.length === 0
	) {
		return null;
	}

	return (
		<ReportsWidgetView
			modules={reportStatus.reportModules}
			ewrUrl={reportStatus.ewrUrl}
			onOpenEwr={handleEwrClick}
		/>
	);
};
